<nav class="navbar navbar-expand-lg navbar-dark  bg-dark">
    <a class="navbar-brand" routerLink="./infections">COVID-19-TN</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item " routerLinkActive="active">
            <a class="nav-link" routerLink="./infections" >Nouvelles infections </a>
        </li>
        <li class="nav-item " routerLinkActive="active">
            <a class="nav-link" routerLink="./allinfections">Tous les infections </a>
        </li>
        <li class="nav-item " routerLinkActive="active">
          <a class="nav-link " routerLink="./numbers">Situation en chiffre</a>
        </li>
        
        <li class="nav-item " routerLinkActive="active">
            <a class="nav-link log-out" (click)="logOut()" style="padding-left: 15px;">Se déconnecter </a>
        </li>
        

        
        
  
        
      </ul>

    </div>
  </nav>

  <router-outlet></router-outlet>